import { Button } from "react-bootstrap";
import { Download } from "lucide-react";
import StatusBadge from "../../Common/StatusBadge";
import {
  User_Certificate_Accred,
  User_Certificate_Certificate,
} from "../../../../config/adminUrlConfig";
import { UserCertificate } from "../../../../config/apiServices";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Placeholder component as per design image
const DigitalCertificates = ({ userData }) => {
  const [certifications, setCertifications] = useState([]);
  const [accreditations, setAccreditations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userData?.atom_id) return;
    const atomId = userData.atom_id;
    UserCertificate.get(`${User_Certificate_Certificate}/${atomId}`)
      .then((res) => {
        const data = res.data;
        setCertifications(Array.isArray(data.data) ? data.data : []);
      })
      .catch(() => setCertifications([]));
    UserCertificate.get(`${User_Certificate_Accred}/${atomId}`)
      .then((res) => {
        const data = res.data;
        setAccreditations(Array.isArray(data.data) ? data.data : []);
      })
      .catch(() => setAccreditations([]));
  }, [userData]);

  const handleViewAllCertificates = () => {
  navigate("/Certificate", {
    state: {
      atomId: userData?.atom_id,
      from: "dashboard",
    },
  });
};
  const handleViewAllAccreditation = () => {
  navigate("/Accreditation", {
    state: {
      atomId: userData?.atom_id,
    },
  });
};

  return (
    <div className="py-2">
      {/* Certifications */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="fw-medium fs-4 text-black">Certifications</h6>
        <Button
          variant="outline-dark"
          style={{ borderColor: "#e5e7eb" }}
          onClick={handleViewAllCertificates}
        >
          View All
        </Button>
      </div>

      <div className="table-responsive mb-4 rounded border">
        <table className="table table-striped table-borderless align-middle mb-0">
          <thead
            className=""
            style={{ backgroundColor: "#753FC9", color: "white" }}
          >
            <tr>
              <th className="py-3 ps-3">Event Name</th>
              <th className="py-3">Date</th>
              <th className="py-3 pe-3 text-end">Action</th>
            </tr>
          </thead>
          <tbody>
            {certifications.map((item, idx) => (
              <tr key={idx} style={{ borderBottom: "1px solid #f0f0f0" }}>
                <td className="ps-3 py-3 text-muted">{item.eventName}</td>
                <td className="py-3 text-muted">
                  {new Date(item.createdAt).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </td>
                <td className="py-3 pe-3 text-end">
                  <Button
                    onClick={() => window.open(item.link)}
                    variant="Secondary"
                    size="sm"
                    className="rounded border"
                    style={{ backgroundColor: "#F3F4F6" }}
                  >
                    <Download size={14} className="text-black" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Accreditation */}
      <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
        <h6 className="fw-medium fs-4 text-black">Accreditation</h6>
        <Button
          variant="outline-dark"
          style={{ borderColor: "#e5e7eb" }}
          onClick={handleViewAllAccreditation}
        >
          View All
        </Button>
      </div>

      <div className="table-responsive rounded border">
        <table className="table table-striped table-borderless align-middle mb-0">
          <thead
            className=""
            style={{ backgroundColor: "#753FC9", color: "white" }}
          >
            <tr>
              <th className="py-3 ps-3">Event Name</th>
              <th className="py-3">Date</th>
              <th className="py-3 pe-3 text-end">Action</th>
            </tr>
          </thead>
          <tbody>
            {accreditations.map((item, idx) => (
              <tr key={idx} style={{ borderBottom: "1px solid #f0f0f0" }}>
                <td className="ps-3 py-3 text-muted">{item.eventName}</td>
                <td className="py-3 text-muted">{new Date(item.createdAt).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}</td>
                <td className="py-3 pe-3 text-end">
                  <Button
                  onClick={() => window.open(item.link)}
                    variant="light"
                    size="sm"
                    className="rounded border"
                    style={{ backgroundColor: "#F3F4F6" }}
                  >
                    <Download size={14} className="text-black" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DigitalCertificates;
